import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { websiteRoutes } from "./routes";
import WebsiteLayout from "./pages/layout/";
import { ActiveProjectProvider } from "./context/ActiveProjectContext"
function App() {
  // const helmetContext = {};

  return (
    <React.Fragment>
      {/* <HelmetProvider context={helmetContext}> */}
      {/* <ActiveProjectProvider> */}
        <Routes>
          {websiteRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<WebsiteLayout>{route.component}</WebsiteLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Routes>
      {/* </ActiveProjectProvider> */}
      {/* </HelmetProvider> */}
    </React.Fragment>
  );
}

export default App;
